import {
  getApiErrorMessage,
  isPaymentProviderRejectedError,
  isPaymentProviderUnavailableError,
} from '@massilia/queries'

/**
 * Classe l'échec du lancement de paiement. Le message affiché est celui de
 * l'API quand il existe : il est déjà rédigé pour le client (panne prestataire,
 * date d'acompte dépassée, mode de paiement basculé…).
 */
/** Un échec de lancement de paiement classé, avec le texte à montrer au client. */
export interface CheckoutError {
  message?: string
  type: CheckoutErrorType
}

export type CheckoutErrorType = 'error' | 'maintenance' | 'rejected'

export function toCheckoutError(error: Error): CheckoutError {
  const message = getApiErrorMessage(error)

  if (isPaymentProviderUnavailableError(error)) {
    return { message, type: 'maintenance' }
  }

  if (isPaymentProviderRejectedError(error)) {
    return { message, type: 'rejected' }
  }

  return { message, type: 'error' }
}
